import React from "react";
import {
    TIME_MAX_LENGTH,
    TIME_MAX_HOURS,
    TIME_MAX_MINUTES,
    TIME_DO_NOT_CHANGE,
    HOURS_HOURS_REGEX,
} from "consts";
import { toMinutes, appendMissingZero } from "utils";
import { formatTime } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const TimeAutoSuggest = (props) => {
    const getTime = (q) => {
        const trimmedQuery = (q || "").trim();
        const query = trimmedQuery.substring(0, Math.min(trimmedQuery.length, TIME_MAX_LENGTH));
        const matches = HOURS_HOURS_REGEX.exec(query);
        if (!matches) {
            return null;
        }

        let onlyHours = Math.min(Math.max(parseInt(matches[2] || matches[4], 10) || 0, props.minHour), props.maxHour);
        let onlyMinutes = Math.min(Math.max(parseInt(appendMissingZero(matches[6]), 10) || 0, 0), TIME_MAX_MINUTES);

        return toMinutes(onlyHours) + onlyMinutes;
    }

    const onBlur = (e) => {
        if (e.target.value) {
            props.onChange(getTime(e.target.value));
        }
    }

    const suggestTime = (q) => {
        let onlyHours = props.minHour;
        let onlyMinutes = 0;

        const trimmedQuery = (q || "").trim();
        const query = trimmedQuery.substring(0, Math.min(trimmedQuery.length, TIME_MAX_LENGTH));
        const matches = HOURS_HOURS_REGEX.exec(query);
        if (matches) {
            onlyHours = Math.min(Math.max(parseInt(matches[2] || matches[4], 10) || 0, props.minHour), props.maxHour);
            onlyMinutes = Math.min(Math.max(parseInt(appendMissingZero(matches[6]), 10) || 0, 0), TIME_MAX_MINUTES);
        }

        const numbers = [TIME_DO_NOT_CHANGE];
        if (!matches) {
            numbers.push(420);  // 7:00
            numbers.push(450);  // 7:30
            numbers.push(480);  // 8:00
            numbers.push(510);  // 8:30
            onlyHours = 9;
        }
        for (let i = onlyHours; i <= props.maxHour; i++) {
            numbers.push(toMinutes(i));
        }

        const inputMinutes = toMinutes(onlyHours) + onlyMinutes;
        if (matches && inputMinutes >= 0) {
            const hour = toMinutes(Math.floor(inputMinutes / 60));

            numbers.push(hour);
            if (props.appendMinutesAfterMaxHour || (hour / 60 < props.maxHour)) {
                numbers.push(inputMinutes); // exact input time
                numbers.push(hour + 15);    // closest hour + 15 minutes
                numbers.push(hour + 30);    // closest hour + 30 minutes
                numbers.push(hour + 45);    // closest hour + 45 minutes
            }
        }

        numbers.sort((a, b) => (a - b));

        return Promise.resolve(
            numbers
                .filter((minutes) => !props.hideDoNotChange || minutes !== TIME_DO_NOT_CHANGE)
                .filter((minutes) => matches ? minutes >= inputMinutes : true)
                .filter((minutes) => minutes > 0)
                .filter((minutes, index, self) => self.indexOf(minutes) === index)
        )
    }

    return (
        <AutoSuggest
            label={props.label}
            fetchOptions={suggestTime}
            renderOption={(minutes) => ({
                value: minutes,
                label: formatTime(minutes),
            })}
            optionIdentifier={(minutes) => minutes}
            onBlur={onBlur}
            {...props}
        />
    );
}

TimeAutoSuggest.defaultProps = {
    label: 'Time',
    minHour: 0,
    maxHour: TIME_MAX_HOURS,
    appendMinutesAfterMaxHour: true,
}

export default TimeAutoSuggest;
